import Tooltip from "@src/Components/Tooltip"
import {
  DateFormat,
  useUserLocaleDateFormatting,
} from "@src/Hooks/useUserLocaleDateFormatting"
import { IMonitoringDashboardData } from "@src/types"

import { CardSlider } from "../../CardSlider"
import { Description, SliderCardWrapper } from "../../styles"
import { DateInfo } from "../../TrainingCard/styles"
import {
  IssuesCount,
  Main,
  MainSecondSlide,
  ScanInfo,
  ScanInfoWrapper,
  ScanNumber,
  SliderCardHead,
  SuperScript,
} from "../styles"

interface IFilledStateCard {
  data: IMonitoringDashboardData
}

const formatSeverityCount = (count: number) => {
  if (count > 999) {
    return (
      <>
        999<SuperScript>+</SuperScript>
      </>
    )
  }
  return count
}

export const FilledStateCard = ({ data }: IFilledStateCard) => {
  const { formatDate } = useUserLocaleDateFormatting()

  const dateInfoText = () => {
    if (data.webAppsScanned < 1 && !data.isScanInProgress) {
      return "No scans yet"
    } else if (data.isScanInProgress) {
      return "Scan in progress"
    }

    return `Updated ${formatDate(new Date(data.lastScanDate), DateFormat.Date)}`
  }

  const totalIssues =
    (data.webAppsIssues?.criticals || 0) +
    (data.webAppsIssues?.highs || 0) +
    (data.webAppsIssues?.mediums || 0) +
    (data.webAppsIssues?.lows || 0)

  return (
    <>
      <CardSlider>
        <SliderCardWrapper>
          <Main>
            <ScanInfo>
              <ScanNumber>{data.webAppsScanned}</ScanNumber>
              <Description>
                Web{data.webAppsScanned > 1 ? "sites" : "site"}
                <br />
                Scanned
              </Description>
            </ScanInfo>
            <hr />
            <ScanInfo>
              <ScanNumber>{data.scansScheduled}</ScanNumber>
              <Description>
                {data.scansScheduled > 1 ? "Scans" : "Scan"}
                <br />
                Scheduled
              </Description>
            </ScanInfo>
          </Main>
          <DateInfo>{dateInfoText()}</DateInfo>
        </SliderCardWrapper>
        <SliderCardWrapper>
          <SliderCardHead data-tooltip-id="card-wep-apps-monitoring-tooltip">
            {data.targetList?.length}{" "}
            {data.targetList?.length > 1 ? "websites" : "website"}
          </SliderCardHead>
          <IssuesCount>{totalIssues.toLocaleString()} Issues</IssuesCount>
          <MainSecondSlide>
            <ScanInfoWrapper>
              <ScanInfo width="80px">
                <ScanNumber>
                  {formatSeverityCount(data.webAppsIssues?.criticals || 0)}
                </ScanNumber>
                <Description>Critical</Description>
              </ScanInfo>
              <ScanInfo width="80px">
                <ScanNumber>
                  {formatSeverityCount(data.webAppsIssues?.highs || 0)}
                </ScanNumber>
                <Description>High</Description>
              </ScanInfo>
              <ScanInfo width="80px">
                <ScanNumber>
                  {formatSeverityCount(data.webAppsIssues?.mediums || 0)}
                </ScanNumber>
                <Description>Medium</Description>
              </ScanInfo>
              <ScanInfo width="80px">
                <ScanNumber>
                  {formatSeverityCount(data.webAppsIssues?.lows || 0)}
                </ScanNumber>
                <Description>Low</Description>
              </ScanInfo>
            </ScanInfoWrapper>
          </MainSecondSlide>
          <DateInfo>{dateInfoText()}</DateInfo>
        </SliderCardWrapper>
      </CardSlider>
      {!!data.targetList.length && (
        <Tooltip
          id="card-wep-apps-monitoring-tooltip"
          content={
            <p>
              {data.targetList.map((t, index) => (
                <p key={`${t.url}-${index}`}>{t.name}</p>
              ))}
            </p>
          }
        />
      )}
    </>
  )
}
